export default __webpack_public_path__ + "static/media/money-icon.f2eabbca.svg";